import type { DownloadProviderPort } from './DownloadProviderPort';
import downloadjs from 'downloadjs';

export class DownloadProvider implements DownloadProviderPort {
    execute(file: Blob, filename: string): void {
        downloadjs(file, filename);
    }
}
